import { TextField } from '@mui/material';
import React, { ComponentProps, FC, forwardRef, useRef } from 'react';
import { IMaskInput } from 'react-imask';
import { ControlledInput } from '../controlled-input/controlled-input.component';

type Props = ComponentProps<typeof TextField> & {
    name: string;
    mask: string;
    placeholder?: string;
};

export const Mask = forwardRef<typeof IMaskInput>(({ ...props }, ref) => {
    const forwardRef = useRef(ref);
    return <IMaskInput ref={forwardRef} lazy={true} {...props} />;
});

export const ControlledMaskInput: FC<Props> = ({ mask, placeholder, slotProps, ...props }) => {
    return (
        <ControlledInput
            slotProps={{
                input: {
                    inputComponent: Mask as any,
                    ...slotProps?.input,
                },
                htmlInput: { placeholder, mask, lazy: true, ...slotProps?.htmlInput },
            }}
            {...props}
        />
    );
};
